<div class="flex-fill content-background">
  <app-spinner trackerName="global"></app-spinner>
  <router-outlet></router-outlet>
</div>
